import { TurnaroundTime as _TurnaroundTime } from '@team-milva/lab-models/resources'
import { t } from '@/locales'

export class TurnaroundTime extends _TurnaroundTime {
  getName(locale: string): string {
    if (this.type === 'fixed-deadline') {
      const hour = String(this.deadline.hour).padStart(2, '0')
      const minute = String(this.deadline.minute).padStart(2, '0')
      return t('tat.fixed-deadline-duration-text', {
        count: this.workingDays,
        time: `${hour}:${minute}`,
      })
    }
    return (
      this.name[locale] ||
      this.name['en'] ||
      Object.values(this.name).find((v) => v) ||
      ''
    )
  }

  getShortName(): string {
    return this.workingDays === 1
      ? t('W: 1 dag')
      : t('W: {count} dage', { count: this.workingDays })
  }

  get typeName(): string {
    return this.type === 'fixed-deadline'
      ? t('tat.title.fixed-deadline')
      : t('tat.title.walk-in')
  }
}

